"use strict";
exports.__esModule = true;
exports.ThemeColor = void 0;
var ThemeColor;
(function (ThemeColor) {
    ThemeColor["BlueTitleTurquoise"] = "bg-blue-accent-turquoise";
    ThemeColor["BlueTitleYellow"] = "bg-blue-accent-yellow";
    ThemeColor["Yellow"] = "bg-yellow";
    ThemeColor["Red"] = "bg-red";
    ThemeColor["Turquoise"] = "bg-turquoise";
})(ThemeColor = exports.ThemeColor || (exports.ThemeColor = {}));
//# sourceMappingURL=theme-color.js.map